import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import TaskCard from "@/components/TaskCard";
import TaskDetailDrawer from "@/components/TaskDetailDrawer";
import { ArchiveButton } from "@/components/ArchiveButton";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATUS_META } from "@/lib/format";
import CreateTaskDialog from "@/components/CreateTaskDialog";
import { Button } from "@/components/ui/button";
import { Search, Plus } from "lucide-react";

export default function TeamTasks() {
  const [tasks, setTasks] = useState([]);
  const [q, setQ] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [branchFilter, setBranchFilter] = useState("all");
  const [branches, setBranches] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);

  const load = () => api.get("/tasks", { params: { scope: "team" } }).then((r) => setTasks(r.data));
  useEffect(() => { load(); api.get("/branches").then((r) => setBranches(r.data)); }, []);
  const open = (id) => { setOpenId(id); setDrawerOpen(true); };

  const filtered = tasks.filter((t) => {
    if (!t.assignee_user_id && !t.assignee_position) return false;
    const okQ = !q || t.title.toLowerCase().includes(q.toLowerCase());
    const okS = statusFilter === "all" || t.status === statusFilter;
    const okB = branchFilter === "all" || t.branch_id === branchFilter;
    return okQ && okS && okB;
  });

  return (
    <div>
      <div className="mb-6 flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">Tugas Tim</h1>
          <p className="text-slate-500 text-sm">Seluruh tugas dalam jalur laporan Anda (solid & dotted line)</p>
        </div>
        <Button onClick={() => setCreateOpen(true)} data-testid="team-add-task-btn" className="bg-indigo-600 hover:bg-indigo-700">
          <Plus className="h-4 w-4 mr-1" />Tambah Tugas
        </Button>
      </div>

      <div className="flex gap-3 mb-5 flex-wrap">
        <div className="relative flex-1 min-w-[200px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari tugas..." className="pl-9" data-testid="team-task-search" />
        </div>
        <Select value={branchFilter} onValueChange={setBranchFilter}>
          <SelectTrigger className="w-44" data-testid="branch-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Semua Cabang</SelectItem>
            {branches.map((b) => <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={statusFilter} onValueChange={setStatusFilter}>
          <SelectTrigger className="w-52"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Semua Status</SelectItem>
            {Object.entries(STATUS_META).map(([k, v]) => <SelectItem key={k} value={k}>{v.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-16 text-slate-400">Tidak ada tugas tim.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((t) => (
            <div key={t.id} className="relative group">
              <TaskCard task={t} onClick={() => open(t.id)} />
              {t.status === "selesai_terverifikasi" && (
                <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <ArchiveButton url={`/tasks/${t.id}`} label="tugas selesai ini" onDone={load} testid={`archive-task-${t.id}`} className="bg-white shadow" />
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      <CreateTaskDialog open={createOpen} onOpenChange={setCreateOpen} onDone={load} allowOrgWide />
      <TaskDetailDrawer taskId={openId} open={drawerOpen} onOpenChange={setDrawerOpen} onChanged={load} />
    </div>
  );
}
